import {useEffect, useState} from 'react'
import { KTSVG } from '../../../../../../_metronic/helpers'
import {useFormik} from 'formik'
import { is } from 'immutable';
import { ThemeConsumer } from 'react-bootstrap/esm/ThemeProvider';

type Props = {
    toggleShow:any,
    isUpdate: boolean,
    itemToEdit: any
}

const RoleAddEdit: React.FC<Props> = ({toggleShow, isUpdate, itemToEdit}) => {
  
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [formData, setFormData] = useState(isUpdate ? itemToEdit:{'id':'0','name':''});
  
  useEffect(() => {
    document.body.classList.add('modal-open')
    return () => {
      document.body.classList.remove('modal-open')
    }
  }, [])

  const handleSubmit = async (e : any) => {

  e.preventDefault();
  setIsSubmitting(true);
  
  try 
  {
    
    if(!isUpdate){
      // create process
      const response = 
      await fetch(process.env.REACT_APP_API_URL_BACKEND + '/role/create', 
      {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    }
    else
    {
      // update process
      formData["role_id"] = formData.id; //have to add permission_id, because form input name was not affecting post value name
      const response = 
      await fetch(process.env.REACT_APP_API_URL_BACKEND + '/role/update', 
      {
        method: 'PUT',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(formData),
      });
    }

    
    toggleShow();
  } 
  catch (error) 
  {
    console.log(error);
  }
};

const handleChange = (e : any) => {

  setFormData(
    {...formData, 
      [e.target.name]: e.target.value}
    );
};


  return (
    <>
      <div
        className='modal fade show d-block'
        id='kt_modal_add_user'
        role='dialog'
        tabIndex={-1}
        aria-modal='true'>
        <form id='kt_modal_add_role_form' onSubmit={handleSubmit} className='form' noValidate>
        {/* begin::Modal dialog */}
        <div className='modal-dialog modal-dialog-centered mw-650px'>
          {/* begin::Modal content */}
          <div className='modal-content'>
            {/* <UserEditModalHeader /> */}
            <div className='modal-header'>
              {/* begin::Modal title */}
              <h2 className='fw-bold'>
              {isUpdate ? 'Change Role' : 'Add Role'}
              </h2>
              {/* end::Modal title */}

              {/* begin::Close */}
              <div
                className='btn btn-icon btn-sm btn-active-icon-primary'
                data-kt-users-modal-action='close'
                onClick={toggleShow}
                style={{cursor: 'pointer'}}>
                <KTSVG path='/media/icons/duotune/arrows/arr061.svg' className='svg-icon-1' />
              </div>
              {/* end::Close */}
            </div>

            {/* begin::Modal body */}
            <div className='modal-body scroll-y mx-5 mx-xl-15 my-7'>
              {/* <UserEditModalFormWrapper /> */}
              
              <div className='fv-row mb-7'>              
                {/* hidden field is for id if the modal is open in Update mode */}

                <input type="hidden" name="role_id" value={formData ? formData.id: 0} onChange={handleChange}/>  
                
                <label className='required fw-semibold fs-6 mb-2'>Role Name</label>                
                <input
                type='text'
                name='name'
                className='form-control form-control-solid mb-3 mb-lg-0'
                autoComplete='off'
                onChange={handleChange}
                value={formData ? formData.name : ''}
                />
              </div>

              <button
                type='reset'
                onClick={() => toggleShow(0)}
                className='btn btn-light me-3'
                data-kt-users-modal-action='cancel'
              >
                Discard
              </button>

              <button
              type='submit'
              className='btn btn-primary'
              data-kt-users-modal-action='submit'
              disabled={isSubmitting}>
              <span className='indicator-label'>{isUpdate ? 'Update' : 'Save'}</span>
              </button>
            </div>
            {/* end::Modal body */}
          </div>
          {/* end::Modal content */}
        </div>
        {/* end::Modal dialog */}
        </form>      
      </div>
      {/* begin::Modal Backdrop */}
      <div className='modal-backdrop fade show'></div>
      {/* end::Modal Backdrop */}
    </>
  )
}

export {RoleAddEdit}
